export const GET_NOTIFICATIONS_BEGIN = 'GET_NOTIFICATIONS_BEGIN'
export const GET_NOTIFICATIONS_SUCCESS = 'GET_NOTIFICATIONS_SUCCESS'
export const GET_NOTIFICATIONS_ERROR = 'GET_NOTIFICATIONS_ERROR'

export const MARK_NOTIFICATION_READ_BEGIN = 'MARK_NOTIFICATION_READ_BEGIN'
export const MARK_NOTIFICATION_READ_SUCCESS = 'MARK_NOTIFICATION_READ_SUCCESS'
export const MARK_NOTIFICATION_READ_ERROR = 'MARK_NOTIFICATION_READ_ERROR'

export const HYDRATE_NOTIFICATIONS = 'HYDRATE_NOTIFICATIONS'
